import React, { useContext } from "react";

import { IonAvatar, IonRippleEffect, IonSpinner } from "@ionic/react";

import AvatarIcon from "../../assets/avatar.svg";
import { AppContext } from "../../base/AppContext";

import "./user-photo-style.css";

export const UserPhoto: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
  const { user, loading } = useContext(AppContext);
  return (
    <IonAvatar
      className={`ion-activatable ripple-parent ${
        loading ? "ion-photo-loading" : ""
      }`}
      onClick={onClick}
    >
      {loading ? <IonSpinner color="primary" /> : null}
      <img src={user.photo || AvatarIcon} alt={user?.name} />
      <IonRippleEffect />
    </IonAvatar>
  );
};
